import React from 'react';

import { SVGComponentProps } from './svg.types';

const LabelSVG = ({ fill = '#D5D7DD', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="none" />
      <path
        d="M14.0827 7H5.78103C5.57381 7 5.37522 7.08775 5.22879 7.24414C5.08236 7.40038 5 7.61231 5 7.83327V16.1667C5 16.3877 5.08236 16.5996 5.22879 16.7559C5.37522 16.9123 5.57382 17 5.78103 17H14.0827C14.2691 17 14.4493 16.9289 14.5909 16.7994L18.4546 13.2655C18.8008 12.9489 19 12.4867 19 12.0001C19 11.5136 18.8008 11.0513 18.4546 10.7347L14.5909 7.20073C14.4493 7.07127 14.2691 7.00012 14.0827 7.00012V7Z"
        fill="#BCBEC2"
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke={fill} />
    </svg>
  );
};

export default LabelSVG;
